import { NgModule } from '@angular/core';
import { UserMetadataComponent } from './pages/user-metadata/user-metadata.component';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './routes/auth.routes';

@NgModule({
  declarations: [UserMetadataComponent],
  providers: [],
  imports: [CommonModule, AuthRoutingModule],
  exports: []
})
export class ZonarUiAuthModule {}
